import React from 'react';
import { OnboardingStepGate } from '../../components/OnboardingStepGate';
import { ROUTES_PATH } from '../../constants/Routes';
import { useOnboardingTools } from './useOnboardingTools';

interface OnboardingToolsGateProps {
  children: React.ReactNode;
  isExempt?: boolean;
}

export function OnboardingToolsGate({ children, isExempt }: OnboardingToolsGateProps) {
  const { status, isPollingCredits, oabSkipped } = useOnboardingTools();
  // Only the skipped-OAB branch is forced here: lawyers and non-lawyers who finished the profile before the
  // tools step existed are not dragged into it.
  const gateStatus = status === 'ready' && !oabSkipped ? 'completed' : status;

  return (
    <OnboardingStepGate
      status={gateStatus}
      stepPath={ROUTES_PATH.ONBOARDING.TOOLS}
      isPollingCredits={isPollingCredits}
      isExempt={isExempt}
    >
      {children}
    </OnboardingStepGate>
  );
}

export default OnboardingToolsGate;
